import { mergeTranslationResources, sharedTranslationResources } from './base.js'
import en from './apps/cloud-web/locales/en.json' with { type: 'json' }
import zh from './apps/cloud-web/locales/zh.json' with { type: 'json' }
import ja from './apps/cloud-web/locales/ja.json' with { type: 'json' }
import ko from './apps/cloud-web/locales/ko.json' with { type: 'json' }
import fr from './apps/cloud-web/locales/fr.json' with { type: 'json' }

type AppTranslationResources = Record<string, { translation: Record<string, unknown> }>

const localResources = {
  en: { translation: en },
  zh: { translation: zh },
  ja: { translation: ja },
  ko: { translation: ko },
  fr: { translation: fr },
}

export const cloudTranslationResources: AppTranslationResources = mergeTranslationResources(sharedTranslationResources, localResources) as AppTranslationResources